<template>
  <div class="top-middle-cmp-all box box_v">

    <div class="top-middle-cmp box_f1 box box_v">
      <div class="tuli box box_i_center">
        <span class="tuli_icon" style="background-color:#f5d94e "></span><span class="tuli_title">金银珠宝</span>
        <span class="tuli_icon" style="background-color:#00f52e "></span><span class="tuli_title">家电</span>
        <span class="tuli_icon" style="background-color:#f54500 "></span><span class="tuli_title">超市</span>
        <span class="tuli_icon" style="background-color:#0800f5 "></span><span class="tuli_title">百货餐饮</span>
      </div><!--2个超市和商场的-->
      <div class="chart-name">
        当日核销数
        <dv-decoration-3 style="width:100px;height:15px;" />
      </div>
      <div class="box_f1" style="position: relative;">
        <div class="charDiv">
          <dv-charts :option="countHourOption" />
        </div>
      </div>
    </div>



    <div class="top-middle-cmp box_f1">
      <div class="chart-name">
        拉动消费额
        <dv-decoration-3 style="width:100px;height:15px;" />
      </div>
      <dv-charts :option="countConsumeOption" />
    </div>

    <div class="top-middle-cmp box_f1 box box_v">
      <div class="tuli box box_i_center">
        <span class="tuli_icon" style="background-color:#f5d94e "></span><span class="tuli_title">金银珠宝</span>
        <span class="tuli_icon" style="background-color:#00f52e "></span><span class="tuli_title">家电</span>
        <span class="tuli_icon" style="background-color:#f54500 "></span><span class="tuli_title">超市</span>
        <span class="tuli_icon" style="background-color:#0800f5 "></span><span class="tuli_title">百货餐饮</span>
      </div><!--2个超市和商场的-->
      <div class="chart-name">
        每日核销数
        <dv-decoration-3 style="width:100px;height:15px;" />
      </div>
      <div class="box_f1" style="position: relative;">
        <div class="charDiv">
          <dv-charts :option="countDayOption" />
        </div>
      </div>
    </div>


  </div>


</template>

<script>
    export default {
      name: "centerCharts",
      computed: {
        xiaofeiquanVue() {
          return this.$store.state.xiaofeiquanVue
        },
      },
      created() {
        this.load()
      },
      methods: {
        load() {
          //GET /api/coupon-count/ctt2/amount/count4line
          //消费金额统计--当日(08~22点)/每日 拉动消费额线型图（按照时间/日期正序无间隔排列）
          let time = new Date().getTime()
          let date = this.$util.FormatDate(time, "yyyy-MM-dd")
          // this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/amount/count4line',{
          //   beginDate: date,
          //   endDate: date
          // },res=> {
          {
            let res = {
              "isSucceed": true,
              "message": "",
              "rows": [{"dateTime": "08:00", "amount": 15772.51}, {
                "dateTime": "09:00",
                "amount": 539049.42
              }, {"dateTime": "10:00", "amount": 1350766.59}, {
                "dateTime": "11:00",
                "amount": 1669666.47
              }, {"dateTime": "12:00", "amount": 1156924.88}, {
                "dateTime": "13:00",
                "amount": 929770.9
              }, {"dateTime": "14:00", "amount": 1112090.11}, {
                "dateTime": "15:00",
                "amount": 1388855.33
              }, {"dateTime": "16:00", "amount": 1607517.92}, {
                "dateTime": "17:00",
                "amount": 1712602.48
              }, {"dateTime": "18:00", "amount": 1764913.29}, {
                "dateTime": "19:00",
                "amount": 1323206.63
              }, {"dateTime": "20:00", "amount": 999828.77}, {
                "dateTime": "21:00",
                "amount": 634904.24
              }, {"dateTime": "22:00", "amount": 52174.9}],
              "footer": [],
              "total": null,
              "newPrimaryKeys": {},
              "mqObj": null,
              "code": 1
            }
            let xAxis_data = []
            let series_0_data = []
            for (let i = 0; i < res.rows.length; i++) {
              series_0_data.push(res.rows[i].amount)
              xAxis_data.push(res.rows[i].dateTime)
            }
            this.countConsumeOption = this.oneOption(xAxis_data, series_0_data)
          }
          //})
          //核销数统计--当日(08~22点)/每日 核销数线型图（按照时间/日期正序无间隔排列
          // this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/consume/count4line',{
          //   beginDate: date,
          //   endDate: date
          // },res=> {
          {
            let res = {"isSucceed":true,"message":"","rows":[{"dateTime":"08:00","supermarketConsumeNum":132,"marketConsumeNum":8,"jewelryConsumeNum":0,"deviceConsumeNum":2},{"dateTime":"09:00","supermarketConsumeNum":1272,"marketConsumeNum":634,"jewelryConsumeNum":1,"deviceConsumeNum":241},{"dateTime":"10:00","supermarketConsumeNum":2066,"marketConsumeNum":2403,"jewelryConsumeNum":22,"deviceConsumeNum":518},{"dateTime":"11:00","supermarketConsumeNum":2208,"marketConsumeNum":3187,"jewelryConsumeNum":14,"deviceConsumeNum":673},{"dateTime":"12:00","supermarketConsumeNum":1632,"marketConsumeNum":3003,"jewelryConsumeNum":5,"deviceConsumeNum":424},{"dateTime":"13:00","supermarketConsumeNum":1246,"marketConsumeNum":2891,"jewelryConsumeNum":1,"deviceConsumeNum":291},{"dateTime":"14:00","supermarketConsumeNum":1287,"marketConsumeNum":3224,"jewelryConsumeNum":7,"deviceConsumeNum":364},{"dateTime":"15:00","supermarketConsumeNum":1730,"marketConsumeNum":3454,"jewelryConsumeNum":12,"deviceConsumeNum":467},{"dateTime":"16:00","supermarketConsumeNum":1921,"marketConsumeNum":3617,"jewelryConsumeNum":9,"deviceConsumeNum":608},{"dateTime":"17:00","supermarketConsumeNum":2221,"marketConsumeNum":3869,"jewelryConsumeNum":9,"deviceConsumeNum":597},{"dateTime":"18:00","supermarketConsumeNum":2381,"marketConsumeNum":3747,"jewelryConsumeNum":43,"deviceConsumeNum":575},{"dateTime":"19:00","supermarketConsumeNum":2553,"marketConsumeNum":3237,"jewelryConsumeNum":13,"deviceConsumeNum":369},{"dateTime":"20:00","supermarketConsumeNum":2293,"marketConsumeNum":2822,"jewelryConsumeNum":5,"deviceConsumeNum":187},{"dateTime":"21:00","supermarketConsumeNum":869,"marketConsumeNum":1392,"jewelryConsumeNum":9,"deviceConsumeNum":167},{"dateTime":"22:00","supermarketConsumeNum":16,"marketConsumeNum":60,"jewelryConsumeNum":0,"deviceConsumeNum":39}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1}
            let xAxis_data = []
            let series_0_data = []
            let series_1_data = []
            let series_2_data = []
            let series_3_data = []
            for (let i = 0; i < res.rows.length; i++) {
              series_0_data.push(res.rows[i].jewelryConsumeNum)
              series_1_data.push(res.rows[i].deviceConsumeNum)
              series_2_data.push(res.rows[i].supermarketConsumeNum)
              series_3_data.push(res.rows[i].marketConsumeNum)
              if (xAxis_data.indexOf(res.rows[i].dateTime) == -1) {
                xAxis_data.push(res.rows[i].dateTime)
              }
            }
            this.countHourOption = this.twoOption(xAxis_data, series_0_data, series_1_data, series_2_data, series_3_data)
        }
          // })

          // this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/consume/count4line',{
          //   beginDate: '2020-11-06',
          //   endDate: '2020-11-15'
          // },res=> {
          {
            let res = {"isSucceed":true,"message":"","rows":[{"dateTime":"11-06","supermarketConsumeNum":8870,"marketConsumeNum":6453,"jewelryConsumeNum":31,"deviceConsumeNum":163},{"dateTime":"11-07","supermarketConsumeNum":16905,"marketConsumeNum":20993,"jewelryConsumeNum":86,"deviceConsumeNum":3124},{"dateTime":"11-08","supermarketConsumeNum":23828,"marketConsumeNum":37548,"jewelryConsumeNum":150,"deviceConsumeNum":5732},{"dateTime":"11-09","supermarketConsumeNum":11412,"marketConsumeNum":19397,"jewelryConsumeNum":85,"deviceConsumeNum":2142},{"dateTime":"11-10","supermarketConsumeNum":9336,"marketConsumeNum":16216,"jewelryConsumeNum":87,"deviceConsumeNum":2014},{"dateTime":"11-11","supermarketConsumeNum":4170,"marketConsumeNum":5650,"jewelryConsumeNum":40,"deviceConsumeNum":995},{"dateTime":"11-12","supermarketConsumeNum":2293,"marketConsumeNum":5065,"jewelryConsumeNum":17,"deviceConsumeNum":277},{"dateTime":"11-13","supermarketConsumeNum":527,"marketConsumeNum":1104,"jewelryConsumeNum":2,"deviceConsumeNum":44},{"dateTime":"11-14","supermarketConsumeNum":14,"marketConsumeNum":20,"jewelryConsumeNum":0,"deviceConsumeNum":5},{"dateTime":"11-15","supermarketConsumeNum":0,"marketConsumeNum":0,"jewelryConsumeNum":0,"deviceConsumeNum":0}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1}
            let xAxis_data = []
            let series_0_data = []
            let series_1_data = []
            let series_2_data = []
            let series_3_data = []
            for (let i = 0; i < res.rows.length; i++) {
              series_0_data.push(res.rows[i].jewelryConsumeNum)
              series_1_data.push(res.rows[i].deviceConsumeNum)
              series_2_data.push(res.rows[i].supermarketConsumeNum)
              series_3_data.push(res.rows[i].marketConsumeNum)
              if (xAxis_data.indexOf(res.rows[i].dateTime) == -1) {
                xAxis_data.push(res.rows[i].dateTime)
              }
            }
            this.countDayOption = this.twoOption(xAxis_data, series_0_data, series_1_data, series_2_data, series_3_data)
          }
          // })
        },
        oneOption(xAxis_data, series_0_data) {
          if(xAxis_data.length===0) {
            return {}
          }else if(xAxis_data.length===1) {
            xAxis_data.unshift('')
            series_0_data.unshift(0)
            xAxis_data.push('')
            series_0_data.push(0)
          }else if(xAxis_data.length===2) {
            xAxis_data.unshift('')
            series_0_data.unshift(0)
          }
          return {
            grid: {
              top: 30,
              // left: 30,
              right: 0,
              bottom: 30
            },
            xAxis: {
              data: xAxis_data,
              axisLine: {
                style: {
                  stroke: '#ccc'
                }
              },
              axisLabel: {
                style: {
                  fill: '#ccc'
                }
              },
              axisTick: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLine: {
                style: {
                  stroke: '#ccc'
                }
              },
              axisLabel: {
                style: {
                  fill: '#ccc'
                }
              },
              axisTick: {
                show: false
              }
            },
            series: [
              {
                data: series_0_data,
                type: 'line',
                smooth: true,
                lineArea: {
                  show: true,
                  gradient: ['rgba(55, 162, 218, 0.6)', 'rgba(55, 162, 218, 0)']
                },
                lineStyle: {
                  lineDash: [5, 5]
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#00db95'
                  }
                }
              }
            ]
          }
        },
        twoOption(xAxis_data, series_0_data, series_1_data, series_2_data, series_3_data) {
          if(xAxis_data.length===0) {
            return {}
          }else if(xAxis_data.length===1) {
            xAxis_data.unshift('')
            series_0_data.unshift(0)
            series_1_data.unshift(0)
            series_2_data.unshift(0)
            series_3_data.unshift(0)
            xAxis_data.push('')
            series_0_data.push(0)
            series_1_data.push(0)
            series_2_data.push(0)
            series_3_data.push(0)
          }else if(xAxis_data.length===2) {
            xAxis_data.unshift('')
            series_0_data.unshift(0)
            series_1_data.unshift(0)
            series_2_data.unshift(0)
            series_3_data.unshift(0)
          }
          return {
            grid: {
              top: 20,
              // left: 30,
              right: 0,
              bottom: 30
            },
            xAxis: {
              data: xAxis_data,
              axisLine: {
                style: {
                  stroke: '#ccc'
                }
              },
              axisLabel: {
                style: {
                  fill: '#ccc'
                }
              },
              axisTick: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLine: {
                style: {
                  stroke: '#ccc'
                }
              },
              axisLabel: {
                style: {
                  fill: '#ccc'
                }
              },
              axisTick: {
                show: false
              }
            },
            series: [
              {
                name: '金银珠宝',
                data: series_0_data,
                type: 'line',
                smooth: true,
                lineArea: {
                  show: true,
                  gradient: ['rgba(245, 217, 78, 0.6)', 'rgba(245, 217, 78, 0)']
                },
                lineStyle: {
                  stroke: '#f5d94e',
                  lineDash: [5, 5]
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#f5d94e',
                    stroke: 'transparent'
                  }
                }
              },
              {
                data: series_1_data,
                type: 'line',
                smooth: true,
                name: '家电',
                lineArea: {
                  show: true,
                  gradient: ['rgba(0, 245, 46, 0.6)', 'rgba(0, 245, 46, 0)']
                },
                lineStyle: {
                  stroke: '#00f52e'
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#00f52e',
                    stroke: 'transparent'
                  }
                }
              },
              {
                data: series_2_data,
                type: 'line',
                smooth: true,
                name: '超市',
                lineArea: {
                  show: true,
                  gradient: ['rgba(245, 69, 0, 0.6)', 'rgba(245, 69, 0, 0)']
                },
                lineStyle: {
                  stroke: '#f54500'
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#f54500',
                    stroke: 'transparent'
                  }
                }
              },
              {
                data: series_3_data,
                type: 'line',
                smooth: true,
                name: '百货餐饮',
                lineArea: {
                  show: true,
                  gradient: ['rgba(8, 0, 245, 0.6)', 'rgba(8, 0, 245, 0)']
                },
                lineStyle: {
                  stroke: '#0800f5'
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#0800f5',
                    stroke: 'transparent'
                  }
                }
              }
            ]
          }
        }
      },
      data() {
        return {
          countHourOption: {},
          countConsumeOption: {},
          countDayOption: {}
        }
      }
    }
</script>

<style lang="less">
  .top-middle-cmp-all {
      position: relative;
      height: 100%;
      width: 100%;
      box-sizing: border-box;

    .top-middle-cmp {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      /*border: 1px solid #f20;*/
      /*overflow: hidden;*/
      .chart-name {
        position: absolute;
        right: 10px;
        top: 10px;
        text-align: right;
        font-size: 15px;
      }

      .tuli{
        position: absolute;
        right: 100px;
        top: 12px;
        .tuli_icon {
          display: block;
          width: 10px;
          height: 10px;
          border-radius: 10px;
          margin-right: 5px;
        }
        .tuli_title {
          font-size: 13px;
          margin-right: 5px;
        }
      }

      .charDiv {
        position: absolute;
        left: 0;
        top: 0;
        bottom:0;
        right:0;
      }

    }
  }

</style>
